import { updateLanguageBundle } from '@nackle/intl-tools'; //import { CMX_ENDPOINT } from '../config/endpoints.js';

import DEFAULTS from '../const/defaults';
export const loadTranslations = async (token, locale = 'en-US', environment) => {
  let CMX_ENDPOINT = 'https://api.biw.cloud/v2/cmx';

  if (environment === 'qa') {
    CMX_ENDPOINT = 'https://qa.api.biw.cloud/v2/cmx';
  } else {
    if (environment === 'pprd') {
      CMX_ENDPOINT = 'https://pprd.api.biw.cloud/v2/cmx';
    }
  }

  try {
    const response = await fetch(`${CMX_ENDPOINT}/bundle/${encodeURIComponent(DEFAULTS.CMX_BUNDLE_NAME)}`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        'authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        locales: [locale]
      })
    });

    if (response.ok) {
      const bundle = await response.json();
      updateLanguageBundle(bundle.bundles[locale]);
      return {
        success: true
      };
    } else {
      return {
        success: false
      };
    }
  } catch (error) {
    return {
      success: false
    };
  }
};
//# sourceMappingURL=cmx-service.js.map